module.exports = __webpack_public_path__ + "img/factory2.59ebb601.jpg";